import { OrganizationLinkBase, OrganizationLinkPressable } from './components';
import { OrganizationLinkContactUs } from './variations/OrganizationLinkContactUs';
import { OrganizationLinkPrivacyChoices } from './variations/OrganizationLinkPrivacyChoices';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLink = {
  Base: OrganizationLinkBase,
  Pressable: OrganizationLinkPressable,
  PrivacyChoices: OrganizationLinkPrivacyChoices,
  ContactUs: OrganizationLinkContactUs,
};
